<template>
	<div :class="isPc == true ? 'about warp' : ''">
		<div v-if="isPc == true" class="Nav-left">
			<ul>
				<li class="bluefont" :style="cur == index ? 'background-color: #0060B1; color: #fff;' : ''" @click="change(index)" v-for="(item, index) in navlist" :key="index">
					{{ item }}
				</li>
			</ul>
		</div>
		<div v-if="isPc == false" class="mob-tabar">
			<ul class="warp-mob bluefont">
				<li
					:style="cur == index ? 'background:linear-gradient(to top, #005FB2, #2583D4);color: #fff;' : ''"
					@click="tabarchange(index)"
					v-for="(item, index) in navlist"
					:key="index"
				>
					{{ item }}
				</li>
			</ul>
		</div>

		<div :class="isPc == true ? 'article' : 'article-mob warp-mob'">
			<div class="articleTitle bluefont">{{ data.title }}</div>
			<div class="articleText">
				<div v-html="data.textcontent"></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'WebLijinhospitalNursing',

	data() {
		return {
			isPc: true,
			cur: 0,
			navlist: [],
			pid: 17,
			data: null
		};
	},

	mounted() {
		if (document.body.clientWidth <= 820) {
			this.isPc = false;
			console.log(this.isPc);
		} else {
			this.isPc = true;
			console.log(this.isPc);
		}
		this.getdata(0);
	},

	methods: {
		change(index) {
			this.cur = index;
			this.getdata(index);
		},
		tabarchange(index) {
			this.cur = index;
			this.getdata(index);
		},
		getdata(i) {
			let _t = this;
			this.$axios({
				url: 'http://www.ljxzxyy.cn/api/index/article',
				params: {
					pid: _t.pid
				}
			})
				.then((res) => {
					//请求成功
					console.log('article', res.data.data);
					let plist = res.data.data;
					let index_arr = [];
					for (var i1 = 0; i1 < plist.length; i1++) {
						_t.navlist[i1] = plist[i1]['nickname'];
						index_arr[i1] = plist[i1]['id'];
					}
					let category_id = index_arr[i];
					this.$axios({
						url: 'http://www.ljxzxyy.cn/api/index/article',
						params: {
							category_id: category_id,
							num: 1
						}
					})
						.then((response) => {
							//请求成功
							console.log('about', response.data);
							this.$axios({
								url: 'http://www.ljxzxyy.cn/api/index/article',
								params: {
									id: response.data.data.list[0].id
								}
							})
								.then((res) => {
									//请求成功
									console.log('article', res.data);
									this.data = res.data.data;
								})
								.catch((error) => {
									//请求失败
									console.log('article', error);
								});
						})
						.catch((error) => {
							//请求失败
							console.log('about', error);
						});
				})
				.catch((error) => {
					//请求失败
					console.log('article', error);
				});
		}
	}
};
</script>

<style lang="scss" scoped></style>
